import React from "react"

const MessageBanner = ({ active, message, bg }) =>
  (active
    ? <div className="row">
        <div className="two spacing" />

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "10px 50px",
          }}
        >
          <div
            style={{
              textAlign: "center",
              fontSize: "22px",
              flex: 1,
              color: "white",
              border: "1px solid #804000",
              borderRadius: "5px",
              backgroundColor: bg,
              paddingTop: "20px",
              paddingBottom: "20px",
            }}
          >
            {message}
          </div>
        </div>
      </div>
    : null)

export default MessageBanner
